import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import DynamicFormField from './index.tsx';
import { campaignLeadManagementAtom, userInformationAtom } from '../../../Services/_states/index.js';
import { useRecoilState, useRecoilValue } from 'recoil';
import { updateDataWithFieldPermissions } from './helper.ts';

interface DynamicFormFieldsListProps {
  data: any;
  onChange: (index: number, value: any, groupTitle: string) => void;
  // storeEntityValue:(entityForm: any, entityValueId: any,groupTitle: string) => void;
  fieldErrors?: { [key: number]: string };
  phoneNumber?: string | number;
  disabled?: boolean;
  isCreatingLead?: boolean;
  userId?: string | number;
  gridSize?: number;
  multipleFormUpdate?: boolean;
}
interface StatusItem {
  type_of_status?: string;
  status_id?: string;
  status_name?: string;
  substatuses?: SubStatusItem[];
  [key: string]: any;
}

interface SubStatusItem {
  type_of_status?: string;
  [key: string]: any;
}

const DynamicFormFieldsList: React.FC<DynamicFormFieldsListProps> = ({
  data,
  onChange,
  fieldErrors,
  phoneNumber,
  disabled = false,
  isCreatingLead = false,
  multipleFormUpdate = false,
  userId = '',
  gridSize = 4,
}) => {
  const [typeOfStatusList, setTypeOfStatusList] = useState<any>({});
  const [campaignLeadManagementData, setCampaignLeadManagementData] = useRecoilState(
    campaignLeadManagementAtom
  );
  const [permissionData, setPermissionData] = useState<{ [key: string]: any[] }>({});
  const loggedInUser = useRecoilValue(userInformationAtom);

  // const statusList =
  //   campaignLeadManagementData?.statusData?.[ 
  //   campaignLeadManagementData?.selectedForm?.leads_form_id
  //   ] ?? [];

  // useEffect(() => {
  //   const statusData: { [key: string]: any[] } = {};
  //   const statusListTyped: StatusItem[] = statusList as StatusItem[];

  //   statusListTyped?.forEach((item: StatusItem) => {
  //     if (item?.type_of_status) {
  //       if (!statusData[item.type_of_status]) {
  //         statusData[item.type_of_status] = [];
  //       }
  //       const { substatuses, ...rest } = item;
  //       statusData[item.type_of_status].push(rest);
  //     }
  //     item?.substatuses?.forEach((sub: SubStatusItem) => {
  //       const key = sub?.type_of_status ?? 'default';
  //       if (!statusData[key]) {
  //         statusData[key] = [];
  //       }
  //       statusData[key].push({
  //         ...sub,
  //         status_id: item?.status_id,
  //         status_name: item?.status_name,
  //       });
  //     });
  //   });
  //   setTypeOfStatusList(statusData);
  // }, [statusList])

  const statusList = React.useMemo(() => {
    return (
      campaignLeadManagementData?.statusData?.[
      campaignLeadManagementData?.selectedForm?.leads_form_id
      ] ?? []
    );
  }, [
    campaignLeadManagementData?.statusData,
    campaignLeadManagementData?.selectedForm?.leads_form_id,
  ]);

  useEffect(() => {
    const statusData: { [key: string]: any[] } = {};
    const statusListTyped: StatusItem[] = statusList as StatusItem[];

    statusListTyped?.forEach((item: StatusItem) => {
      if (item?.type_of_status) {
        if (!statusData[item.type_of_status]) {
          statusData[item.type_of_status] = [];
        }
        const { substatuses, ...rest } = item;
        statusData[item.type_of_status].push(rest);
      }

      item?.substatuses?.forEach((sub: SubStatusItem) => {
        const key = sub?.type_of_status ?? 'default';
        if (!statusData[key]) {
          statusData[key] = [];
        }
        statusData[key].push({
          ...sub,
          status_id: item?.status_id,
          status_name: item?.status_name,
        });
      });
    });

    // Only update state if content actually changed
    setTypeOfStatusList((prev) => {
      const prevKeys = Object.keys(prev);
      const newKeys = Object.keys(statusData);

      const isEqual =
        prevKeys.length === newKeys.length &&
        prevKeys.every((k) => JSON.stringify(prev[k]) === JSON.stringify(statusData[k]));

      if (isEqual) return prev; // no change
      return statusData;
    });
  }, [statusList]);

  const createDynamicQueryParams = (item: any) => {
    if (item.key_type === 'DROPDOWN' && item?.statusOption === 'is_status') {
      const keyOptions = typeOfStatusList[item?.key_name] ?? [];
      return { ...item, key_type: 'DROPDOWN', key_options: keyOptions };
    } else if (item.key_type === 'DROPDOWN' && item.statusOption === 'is_sub_status') {
      const parentValue = (
        Object.values(data)?.flat() as {
          key_name: string;
          status_parent_key: string;
          alias_name: string;
          value?: any;
          status_config?: { status_id?: string };
        }[]
      )?.find(
        (f) => f?.key_name === item.status_parent_key || f.alias_name === item?.status_parent_key
      );
      const optionsData =
        typeOfStatusList[item?.key_name]?.filter(
          (s) => s?.status_id === parentValue?.status_config?.status_id
        ) ?? []; //getSubstatusOptionsForField(row?.original, field);
      // const subOptions = getNextStatusByStatus(parentValue?.status_config?.status_id);
      return { ...item, key_type: 'DROPDOWN', key_options: optionsData ?? [] };
    }
    if (item?.key_type !== 'ENTITY') {
      return item;
    }
    try {
      const formDataArr = Object?.values(data)?.flat();
      const queryParams: any[] = [];
      if (item?.query_parameter && Array.isArray(item.query_parameter)) {
        item.query_parameter.forEach((param: any) => {
          const findValue: any =
            formDataArr?.find((field: any) => field.alias_name === param?.param) ?? '';
          let paramValue = '';
          let entity_record_id = '';
          if (param?.param === 'global_phone_number') {
            paramValue = phoneNumber || '';
          } else {
            if (findValue?.entity_data && findValue?.entity_data?._id) {
              entity_record_id = findValue?.entity_data?._id ?? '';

              paramValue = findValue?.value?.value ?? findValue?.value ?? '';
            } else {
              paramValue = findValue?.value ?? '';
            }
          }
          queryParams.push({
            matched_with: param.matched_with || '',
            param: param.param || '',
            ...(paramValue && { paramValue: paramValue }),
            ...(entity_record_id && { entity_record_id: entity_record_id }),
            ...(param?.entity_form_field && { entity_form_field: param.entity_form_field }),
            ...(findValue?.is_required && { is_required: findValue?.is_required ?? false }),
          });
        });
      }
      return { ...item, query_parameter: queryParams };
    } catch (error) {
      return item;
    }
  };

  useEffect(() => {
    if (data) {
      const updatedData: { [key: string]: any[] } = {};

      Object.keys(data).forEach((groupTitle) => {
        const groupFields = data[groupTitle];
        if (Array.isArray(groupFields)) {
          const fieldsWithPermissions = updateDataWithFieldPermissions(groupFields, loggedInUser?.profile?.id);
          updatedData[groupTitle] = fieldsWithPermissions;
        } else {
          updatedData[groupTitle] = groupFields;
        }
      });

      setPermissionData(updatedData);
    }
  }, [data, userId]);

  const displayData = Object.keys(permissionData).length > 0 ? permissionData : data;

  return (
    <Box sx={{ overflow: 'visible', pt: 1 }}>
      {Object?.keys(displayData)?.map((groupTitle: string, formDataIndex: number) => {
        // {Object?.keys(data)?.map((groupTitle: string, formDataIndex: number) => {
        return (
          <Box key={groupTitle} mb={2}>
            {groupTitle !== 'Details' && (
              <Box
                sx={{
                  border: '1px solid #D9D9D9',
                  borderRadius: '4px',
                  mb: 2,
                  backgroundColor: '#D9D9D9',
                  padding: '10px',
                }}
              >
                <Typography sx={{ fontWeight: 'bold', color: 'secondary.main' }}>
                  {groupTitle}
                </Typography>
              </Box>
            )}

            <Box className="listform-wrraper"
              sx={{ border: '1px solid #EAEAEA', borderRadius: 1, p: "10px 8px", mt: 0, position: 'relative' }}
            >
              <Grid container spacing={2} key={groupTitle} mb={1} className='innerform-grid'>
                {(Array.isArray(displayData[groupTitle]) ? displayData[groupTitle] : []).flatMap(
                  (item: any, index: any) => {
                    if (
                      item?.access_level === 'none' ||
                      (isCreatingLead &&
                        (item?.statusOption === 'is_status' ||
                          item?.statusOption === 'is_sub_status')) ||
                      (item?.is_static_column ?? false)
                    ) {
                      return null; // Skip rendering this field
                    }
                    if (isCreatingLead && item?.is_primary) {
                      return null;
                    }
                    // 🔥 Hide Lead ID + Phone Number when multipleFormUpdate = true
                    if (multipleFormUpdate &&
                      (item?.key_name === "lead_id" ||
                        item?.key_type === "LEAD_ID" ||
                        item?.label?.toLowerCase() === "lead id" ||
                        item?.key_name === "phone_number")) {
                      return null;
                    }

                    return (
                      <Grid
                        item
                        xs={12}
                        md={
                          item.key_type !== 'CHECKBOX' &&
                            item.key_type !== 'RADIO' &&
                            item.key_type !== 'FILE'
                            ? gridSize
                            : 12
                        }
                        key={item?.key_name || index}
                      >
                        <DynamicFormField
                          item={createDynamicQueryParams(item)}
                          index={index}
                          onChange={onChange}
                          // storeEntityValue={storeEntityValue}
                          groupTitle={groupTitle}
                          fieldErrors={fieldErrors}
                          // disabled={disabled}
                          disabled={disabled || item?.access_level === 'view'}
                        />
                      </Grid>
                    );
                  })}
              </Grid>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default DynamicFormFieldsList;
